
const ThreeDot = () => {
    return (
        <svg
            width="10"
            height="2"
            viewBox="0 0 10 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="1" cy="1" r="1" fill="#A2A2A2" />
            <circle cx="5" cy="1" r="1" fill="#A2A2A2" />
            <circle cx="9" cy="1" r="1" fill="#A2A2A2" />
        </svg>
    );
}

export default ThreeDot;
